<div class="flex flex-col h-screen w-screen overflow-hidden">
  <app-header (toggleMenu)="toggleDrawer()"></app-header>

  <main class="flex-1 relative overflow-hidden flex flex-col">
    <p-scrollPanel styleClass="w-full h-full">
      <div class=" min-h-full p-6">
        <router-outlet></router-outlet>
      </div>
    </p-scrollPanel>
  </main>

  <p-drawer [(visible)]="drawerVisible" position="right" styleClass="!w-64">
    <ng-template pTemplate="headless">
      <app-sidebar class="h-full w-full block"></app-sidebar>
    </ng-template>
  </p-drawer>
</div>